var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap",
        width: "25vw"
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "text-align": "center",
            "font-size": "20px",
            margin: "-5px 0 5px 0"
          }
        },
        [_vm._v("推荐(看是否有人提到过类似的问题)")]
      ),
      _vm._v(" "),
      !_vm.ticketList || _vm.ticketList.length < 1
        ? _c("div", { staticStyle: { color: "#EEE", "font-size": "20px" } }, [
            _vm._v("输入标题后, 系统会匹配已有的可能相关的工单")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.ticketList, function(e) {
        return _c(
          "div",
          { key: e.orderId, staticClass: "ticket-title-line" },
          [
            _c("TicketTitle", {
              staticClass: "ticket-title-line-1",
              attrs: {
                ticketTitle: e.orderTitle,
                ticketNo: e.orderId,
                target: "_blank"
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dfdaba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dfdaba2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/NewTicketRelated.vue
// module id = 962
// module chunks = 75